import { scan } from 'react-scan'; // import this BEFORE react
import '@fontsource-variable/montserrat/index.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { getAxios } from './lib/axios';
import { AllAccessRoles } from 'src/constants/appRoles.ts';
import { App } from 'src/App.tsx';

if (typeof window !== 'undefined' && window.location.hostname.includes('localhost')) {
  scan({
    enabled: false
  });
}

(window as any).getAxios = getAxios;
(window as any).superAdminRoles = AllAccessRoles;

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <Sentry.ErrorBoundary>
    <App />
  </Sentry.ErrorBoundary>
);
